import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { useEventDetails } from '../context';
import NotesWidget from './NotesWidget';
import { EVENT_TAB_SCROLL_END_GAP_PX } from 'src/spacing';
import { db } from '../instant';
import NoEventError from './NoEventError';

interface Props {
    eventId: string;
}

export default function EventNotes(props: Props) {
    const { event, isLoading, error } = useEventDetails(props.eventId);

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" padding={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return <Typography color="error">Error loading event details: {error.message}</Typography>;
    }

    if (!event) {
        return <NoEventError eventId={props.eventId} />;
    }

    const notes = event?.notes || '';

    const setNotes = (notes: string) => {
        console.log(notes);
        db.transact(db.tx.events[props.eventId].update({ notes })).catch(err => console.error('error updating notes: ', err));
    };

    return (
        <Container
            maxWidth="md"
            disableGutters
            sx={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: `${EVENT_TAB_SCROLL_END_GAP_PX}px`,
                px: { xs: 2, sm: 3 },
            }}
        >
            <NotesWidget value={notes} update={setNotes} />
        </Container>
    );
}
